import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { UserContext } from "./utils/user-context";
import { useLocalStorage } from "@uidotdev/usehooks";
import HomePage from "./pages/home-page";
import NewHomePage from "./pages/new-home-page";
import AboutPage from "./pages/AboutPage";
import EventPage from "./pages/EventPage";
import EventDetailPage from "./pages/event-detail-page";
import BusinessPage from "./pages/BusinessPage";
import PolicyPage from "./pages/policy-page";
import ServicePage from "./pages/service-page";
import DeletionPage from "./pages/deletion-page";
import LoginPage from "./pages/login-page";
import BackendPage from "./pages/backend-page";
import ErrorPage from "./pages/error-page";
import { WaveDetailPage } from "./pages/wave-detail-page";
import UniversalLinkPage from "./pages/universal-link-page";
import CommunityGuidelinesPage from "./pages/community-guidelines-page";

const AdminRoutes = () => {
  const [isAuth] = useContext(UserContext);
  return isAuth ? (<BackendPage />) : (<LoginPage />);
}

function App() {
  const [isAuth, setIsAuth] = useState(false);
  const [token] = useLocalStorage('token');

  useEffect(() => {
    if (!!token) {
      setIsAuth(true);
    }
  }, [token])

  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true }}>
      <UserContext.Provider value={[isAuth, setIsAuth]}>
        <Routes>
          <Route path="/" element={<NewHomePage />} />
          <Route path="/home" element={<NewHomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/event" element={<EventPage />} />
          <Route path="/event/:id" element={<EventDetailPage />} />
          <Route path="/business" element={<BusinessPage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route path="/terms" element={<ServicePage />} />
          <Route path="/community" element={<CommunityGuidelinesPage />} />
          <Route path="/web/home" element={<HomePage />} />
          <Route path="/web/policy" element={<PolicyPage />} />
          <Route path="/web/service" element={<ServicePage />} />
          <Route path="/web/deletion" element={<DeletionPage />} />
          <Route path="/web/admin" element={<AdminRoutes />} />
          <Route path="/web/wave/:id" element={<WaveDetailPage />} />
          <Route path="/wave/:id" element={<UniversalLinkPage />} />
          <Route path="/profile/:id" element={<UniversalLinkPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </UserContext.Provider>
    </BrowserRouter>
  );
}

export default App